import React, {useState} from "react" ;
import {Route, Switch, useLocation} from "react-router-dom";

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";

import {
    PATH_USERS_ROOT,
    getUsersRouterLink,
    PATH_USERS_DASHBOARD
} from "root/Wieldy/routePaths";

import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import UsersSubmenu from "./UsersSubmenu";
import UsersDashboardSubmenu from "root/Wieldy/ApplicationModules/Users/Sidebar/UsersDashboardSubmenu";

const UsersAppSidebar= (props) =>
{
    const { pathname }  = useLocation();

    // Note this will change if you add any more items to the AppSidebarGroup below
    const getDefaultMenu = () =>{
        let default_menu = '';

        if(pathname.includes('/users/users')){
            default_menu = 'users';
        }
        else if(pathname.includes('/dashboard')){
            default_menu = 'dashboard';
        }
        else
        {
            //Default to details
            default_menu = 'users';
        }

        return default_menu;
    }

    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default={getDefaultMenu()}>
                        <AppSidebarMenuItem link={getUsersRouterLink('staff')} title='Organisation Users' iconName='icon-family' name='users'/>
                        <AppSidebarMenuItem link={getUsersRouterLink('dashboard')} title='Dashboard' iconName='icon-dashboard' name='dashboard'/>
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_USERS_DASHBOARD} render={(thisprops) => <UsersDashboardSubmenu {...thisprops}/>}/>
                        <Route path={PATH_USERS_ROOT} render={(thisprops) => <UsersSubmenu {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default UsersAppSidebar;
